export default __webpack_public_path__ + "static/media/prirodopis.e0d2cc71.svg";